import { createStyles, Group } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';
import { Button } from '~/domains/design-system/Button';

import type { BaseField, FieldDescriptor, StaticFieldProps } from '../../types/common';

export type PillFieldType = BaseField & {
  type: 'PillField';
  options: { label: string; value: string }[];
  defaultValue: string;
};

const useStyles = createStyles((theme) => ({
  button: {
    border: `1px solid ${theme.colors.gray[5]}`,
    paddingTop: theme.other.spacing._6,
    paddingBottom: theme.other.spacing._6,
    paddingLeft: theme.other.spacing._16,
    paddingRight: theme.other.spacing._16,
    margin: 0,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 100,
    height: 'fit-content',

    '&:hover': {
      background: theme.colors.gray[9],
      '& span': {
        color: theme.white,
      },
    },

    '&.isActive': {
      background: theme.colors.gray[9],
      '& span': {
        color: theme.white,
      },
    },
  },
}));

function PillFieldElement({ field, value, onValueChange }: StaticFieldProps<PillFieldType>) {
  const { classes, cx } = useStyles();

  return (
    <Group /* eslint-disable-line local-rules/use-theme-tokens */ spacing={8} noWrap>
      {field?.options?.map((option) => {
        const isActive = Array.isArray(value)
          ? value.includes(option.value as string | number)
          : value === option.value;

        return (
          <Button
            className={cx(classes.button, {
              isActive,
            })}
            key={option.value}
            variant="text"
            onClick={() => onValueChange?.(option.value)}
          >
            <Text component="span" variant="subhead-small">
              {option.label}
            </Text>
          </Button>
        );
      })}
    </Group>
  );
}

const Descriptor: FieldDescriptor<PillFieldType> = {
  FieldComponent: PillFieldElement,
  name: 'PillField',
};

export default Descriptor;
